"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tokens = require("../styles/tokens");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _excluded = ["classes", "className", "component", "disabled", "href"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  return {
    link: {
      fontFamily: _tokens.fontFamilyDefault,
      lineHeight: _tokens.lineHeightDefault,
      textDecoration: 'underline',
      color: theme.palette.action.base,
      // cta blue 600
      '&:hover': {
        color: theme.palette.action.hover,
        // cta blue 700
        textDecoration: 'underline',
        cursor: 'pointer'
      },
      '&:active': {
        color: theme.palette.action.active,
        // cta blue 800s
        textDecoration: 'underline'
      },
      '&:focus': {
        outline: _tokens.borderWidthThick + " solid " + _tokens.colorBorderGlobalFocus,
        outlineOffset: "" + _tokens.spacing10,
        textDecoration: 'underline',
        borderRadius: _tokens.borderRadiusSmall
      }
    },
    disabled: {
      pointerEvents: 'none',
      color: theme.palette.action.disabled
    }
  };
};
/**
 * Use `TextLink` to take the user to a new page.
 * @done true
 * @updated v6.4.0
 * @versionAdded v0.0.10
 * @examples
 *  TextLinkExample
 *  CustomComponent
 *  TextLinkTarget
 */


var TextLink = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      Component = props.component,
      disabled = props.disabled,
      href = props.href,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var additionalProps = disabled ? {
    'aria-disabled': 'true'
  } : {
    href: href,
    ref: ref
  };
  var classOverrides = {
    stateStyle: (0, _classnames.default)(className, classes.link, (_classNames = {}, _classNames[classes.disabled] = disabled, _classNames))
  };
  (0, _react.useEffect)(function () {
    if (props.component === 'a' && (0, _isEmpty.default)(href)) {
      console.warn("href prop is required for TextLink component.");
    }
  }, [props.component, href]);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: classOverrides.stateStyle
  }, rest, additionalProps));
});

TextLink.muiName = 'TextLink';
TextLink.displayName = 'TextLink';
TextLink.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * Custom className for additional styling
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node. We recommend using a component or element
   * that supports the `href` prop.
   *
   * If you use an element that does not natively have a `tabIndex`, be sure to add a `tabIndex`
   * to make sure the component is keyboard-navigable.
   */
  component: _propTypes.default.elementType,

  /**
   * Set to `true` to disable the link
   */
  disabled: _propTypes.default.bool,

  /**
   * The content of the `TextLink`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * The redirect URL. This prop is required if replacement `component` prop is not specified.
   */
  href: _propTypes.default.string,

  /**
   * Where to display the linked URL, as the name for a browsing context (a tab, window, or `<iframe>`).
   */
  target: _propTypes.default.string
};
TextLink.defaultProps = {
  component: 'a',
  disabled: false
};

var _default = (0, _styles.default)(styles)(TextLink);

exports.default = _default;